import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth-guard';

export const routes: Routes = [

    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
    },
    {
        path: 'login',
        loadChildren: () =>
            import('./login/login-module').then(m => m.LoginModule)
    },
    {
        path: '',
        canActivate: [authGuard],
         loadChildren: () =>
            import('./shared/layout/layout-module').then(m => m.LayoutModule)
    }

    // {
    //     path: '', redirectTo: 'login', pathMatch: 'full',
    // },
    // {
    //     path: '',
    //             loadChildren: () =>
    //         import('./shared/layout/layout-module').then(m => m.LayoutModule)
    // },
    // {
    //     path: 'login',
    //     loadChildren: () =>
    //         import('./login/login-module').then(m => m.LoginModule)
    // },
    // {
    //     path: 'blocks',
    //     loadChildren: () =>
    //         import('./blocks/blocks-module').then(m => m.BlocksModule)
    // }
];
